// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"block_wrapper__PDAjJ","media":"block_media__NEb2b","content":"block_content__VGQAk","heading":"block_heading__HYiox","text":"block_text___FMZe"};